/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
export const gtmEventTypes = {
  BOOK_SERVICE_ENTER_MODEL: 'BOOK_SERVICE_RASF_ENTER_MODEL',
  BOOK_SERVICE_ENTER_VIN_REGO: 'BOOK_SERVICE_RASF_ENTER_VIN_REGO',
  BOOK_SERVICE_ENTER_ODOMETER: 'BOOK_SERVICE_RASF_ENTER_ODOMETER',
  BOOK_SERVICE_SELECT_TITLE: 'BOOK_SERVICE_RASF_SELECT_TITLE',
  BOOK_SERVICE_ENTER_FIRSTNAME: 'BOOK_SERVICE_RASF_ENTER_FIRSTNAME',
  BOOK_SERVICE_ENTER_LASTNAME: 'BOOK_SERVICE_RASF_ENTER_LASTNAME',
  BOOK_SERVICE_ENTER_PHONE: 'BOOK_SERVICE_RASF_ENTER_PHONE',
  BOOK_SERVICE_ENTER_EMAIL: 'BOOK_SERVICE_RASF_ENTER_EMAIL',
  BOOK_SERVICE_SELECT_POSTCODE_SUBURB: 'BOOK_SERVICE_RASF_SELECT_POSTCODE_SUBURB',
  BOOK_SERVICE_DEALER_CLICK_ADDRESS: 'BOOK_SERVICE_RASF_DEALER_CLICK_ADDRESS',
  BOOK_SERVICE_DEALER_CLICK_WEBSITE: 'BOOK_SERVICE_RASF_DEALER_CLICK_WEBSITE',
  BOOK_SERVICE_DEALER_CLICK_PHONE: 'BOOK_SERVICE_RASF_DEALER_CLICK_PHONE',
  BOOK_SERVICE_ENTER_DATE_INPUT: 'BOOK_SERVICE_RASF_ENTER_DATE_INPUT',
  BOOK_SERVICE_SELECT_DROP_OFF_TIME: 'BOOK_SERVICE_RASF_SELECT_DROP_OFF_TIME',
  BOOK_SERVICE_SELECT_PICK_UP_TIME: 'BOOK_SERVICE_RASF_SELECT_PICK_UP_TIME',
  BOOK_SERVICE_ENTER_ENQUIRY: 'BOOK_SERVICE_RASF_ENTER_ENQUIRY',
  BOOK_SERVICE_CHECK_PRIVACY_POLICY: 'BOOK_SERVICE_RASF_CHECK_PRIVACY_POLICY',
  BOOK_SERVICE_CLICK_PRIVACY_POLICY: 'BOOK_SERVICE_RASF_CLICK_PRIVACY_POLICY',
  BOOK_SERVICE_CLICK_SUBMIT: 'BOOK_SERVICE_RASF_CLICK_SUBMIT',
  BOOK_SERVICE_CLICK_GO_BACK: 'BOOK_SERVICE_RASF_CLICK_GO_BACK',
  BOOK_SERVICE_CLICK_EDIT_SERVICE: 'BOOK_SERVICE_RASF_CLICK_EDIT_SERVICE', // Service summary section
}

// Action creators
export const gtmEvents = {
  [gtmEventTypes.BOOK_SERVICE_ENTER_MODEL]: ({model = ''}) => ({
    type: gtmEventTypes.BOOK_SERVICE_ENTER_MODEL,
    event: 'reactjs.event',
    eventID: 'FED-RASF-001',
    pageCategory: 'Request A Service Form',
    pageAction: `Request A Service Form - Entered "${model.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_SERVICE_ENTER_VIN_REGO]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_ENTER_VIN_REGO,
    event: 'reactjs.event',
    eventID: 'FED-RASF-002',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "VINREGO"',
  }),
  [gtmEventTypes.BOOK_SERVICE_ENTER_ODOMETER]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_ENTER_ODOMETER,
    event: 'reactjs.event',
    eventID: 'FED-RASF-003',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "ODOMETER"',
  }),
  [gtmEventTypes.BOOK_SERVICE_SELECT_TITLE]: ({model = ''}) => ({
    type: gtmEventTypes.BOOK_SERVICE_SELECT_TITLE,
    event: 'reactjs.event',
    eventID: 'FED-RASF-004',
    pageCategory: 'Request A Service Form',
    pageAction: `Request A Service Form - Entered "TITLE" - "${model.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_SERVICE_ENTER_FIRSTNAME]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_ENTER_FIRSTNAME,
    event: 'reactjs.event',
    eventID: 'FED-RASF-005',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "FIRSTNAME"',
  }),
  [gtmEventTypes.BOOK_SERVICE_ENTER_LASTNAME]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_ENTER_LASTNAME,
    event: 'reactjs.event',
    eventID: 'FED-RASF-006',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "LASTNAME"',
  }),
  [gtmEventTypes.BOOK_SERVICE_ENTER_PHONE]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_ENTER_PHONE,
    event: 'reactjs.event',
    eventID: 'FED-RASF-007',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "PHONE"',
  }),
  [gtmEventTypes.BOOK_SERVICE_ENTER_EMAIL]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_ENTER_EMAIL,
    event: 'reactjs.event',
    eventID: 'FED-RASF-008',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "EMAIL"',
  }),
  [gtmEventTypes.BOOK_SERVICE_SELECT_POSTCODE_SUBURB]: ({model = ''}) => ({
    type: gtmEventTypes.BOOK_SERVICE_SELECT_POSTCODE_SUBURB,
    event: 'reactjs.event',
    eventID: 'FED-RASF-009',
    pageCategory: 'Request A Service Form',
    pageAction: `Request A Service Form - Selected "POSTCODE/SUBURB" - "${model.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_ADDRESS]: ({dealerName, address}) => ({
    type: gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_ADDRESS,
    event: 'reactjs.event',
    eventID: 'FED-RASF-010',
    pageCategory: 'Request A Service Form',
    pageAction: `Request A Service Form - ${dealerName} - Address "${address}" - Clicked "ADDRESS"`,
  }),
  [gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_WEBSITE]: ({dealerName, address, website}) => ({
    type: gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_WEBSITE,
    event: 'reactjs.event',
    eventID: 'FED-RASF-011',
    pageCategory: 'Request A Service Form',
    pageAction: `Request A Service Form - ${dealerName} - Address "${address}" - Clicked "WEBSITE ${website}"`,
  }),
  [gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_PHONE]: ({dealerName, address, phone}) => ({
    type: gtmEventTypes.BOOK_SERVICE_DEALER_CLICK_PHONE,
    event: 'reactjs.event',
    eventID: 'FED-RASF-012',
    pageCategory: 'Request A Service Form',
    pageAction: `Request A Service Form - ${dealerName} - Address ${address} - Clicked "PHONE ${phone}"`,
  }),
  [gtmEventTypes.BOOK_SERVICE_ENTER_DATE_INPUT]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_ENTER_DATE_INPUT,
    event: 'reactjs.event',
    eventID: 'FED-RASF-013',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "_DATE_INPUT"',
  }),
  [gtmEventTypes.BOOK_SERVICE_SELECT_DROP_OFF_TIME]: ({model = ''}) => ({
    type: gtmEventTypes.BOOK_SERVICE_SELECT_DROP_OFF_TIME,
    event: 'reactjs.event',
    eventID: 'FED-RASF-014',
    pageCategory: 'Request A Service Form',
    pageAction: `Request A Service Form - Submitted Preferred Drop Off Time - "${model.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_SERVICE_SELECT_PICK_UP_TIME]: ({model = ''}) => ({
    type: gtmEventTypes.BOOK_SERVICE_SELECT_PICK_UP_TIME,
    event: 'reactjs.event',
    eventID: 'FED-RASF-015',
    pageCategory: 'Request A Service Form',
    pageAction: `Request A Service Form - Submitted Preferred Pick Up Time - "${model.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_SERVICE_ENTER_ENQUIRY]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_ENTER_ENQUIRY,
    event: 'reactjs.event',
    eventID: 'FED-RASF-016',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Entered "ENQUIRY"',
  }),
  [gtmEventTypes.BOOK_SERVICE_CHECK_PRIVACY_POLICY]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_CHECK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: 'FED-RASF-017',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Checked "PRIVACYPOLICY"',
  }),
  [gtmEventTypes.BOOK_SERVICE_CLICK_PRIVACY_POLICY]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_CLICK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: 'FED-RASF-018',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Clicked "PRIVACYPOLICY"',
  }),
  [gtmEventTypes.BOOK_SERVICE_CLICK_SUBMIT]: ({model = ''}) => ({
    type: gtmEventTypes.BOOK_SERVICE_CLICK_SUBMIT,
    event: 'reactjs.event',
    eventID: 'FED-RASF-019',
    pageCategory: 'Request A Service Form',
    pageAction: `Request A Service Form - Clicked "${model.toUpperCase()}"`,
  }),
  [gtmEventTypes.BOOK_SERVICE_CLICK_GO_BACK]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_CLICK_GO_BACK,
    event: 'reactjs.event',
    eventID: 'FED-RASF-020',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Clicked "GO BACK"',
  }),
  [gtmEventTypes.BOOK_SERVICE_CLICK_EDIT_SERVICE]: () => ({
    type: gtmEventTypes.BOOK_SERVICE_CLICK_EDIT_SERVICE,
    event: 'reactjs.event',
    eventID: 'FED-RASF-021',
    pageCategory: 'Request A Service Form',
    pageAction: 'Request A Service Form - Clicked "EDIT SERVICE"',
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/book-service-duck.js